(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[842],{

/***/ 8273:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "CountUp": function() { return /* binding */ i; }
/* harmony export */ });
var t=function(){return t=Object.assign||function(t){for(var i,n=1,s=arguments.length;n<s;n++)for(var a in i=arguments[n])Object.prototype.hasOwnProperty.call(i,a)&&(t[a]=i[a]);return t},t.apply(this,arguments)},i=function(){function i(i,n,s){var a=this;this.endVal=n,this.options=s,this.version="2.8.0",this.defaults={startVal:0,decimalPlaces:0,duration:2,useEasing:!0,useGrouping:!0,useIndianSeparators:!1,smartEasingThreshold:999,smartEasingAmount:333,separator:",",decimal:".",prefix:"",suffix:"",enableScrollSpy:!1,scrollSpyDelay:200,scrollSpyOnce:!1},this.finalEndVal=null,this.useEasing=!0,this.countDown=!1,this.error="",this.startVal=0,this.paused=!0,this.once=!1,this.count=function(t){a.startTime||(a.startTime=t);var i=t-a.startTime;a.remaining=a.duration-i,a.useEasing?a.countDown?a.frameVal=a.startVal-a.easingFn(i,0,a.startVal-a.endVal,a.duration):a.frameVal=a.easingFn(i,a.startVal,a.endVal-a.startVal,a.duration):a.frameVal=a.startVal+(a.endVal-a.startVal)*(i/a.duration);var n=a.countDown?a.frameVal<a.endVal:a.frameVal>a.endVal;a.frameVal=n?a.endVal:a.frameVal,a.frameVal=Number(a.frameVal.toFixed(a.options.decimalPlaces)),a.printValue(a.frameVal),i<a.duration?a.rAF=requestAnimationFrame(a.count):null!==a.finalEndVal?a.update(a.finalEndVal):a.options.onCompleteCallback&&a.options.onCompleteCallback()},this.formatNumber=function(t){var i,n,s,e,o=t<0?"-":"";i=Math.abs(t).toFixed(a.options.decimalPlaces);var r=(i+="").split(".");if(n=r[0],s=r.length>1?a.options.decimal+r[1]:"",a.options.useGrouping){e="";for(var l=3,h=0,u=0,p=n.length;u<p;++u)a.options.useIndianSeparators&&4===u&&(l=2,h=1),0!==u&&h%l==0&&(e=a.options.separator+e),h++,e=n[p-u-1]+e;n=e}return a.options.numerals&&a.options.numerals.length&&(n=n.replace(/[0-9]/g,(function(t){return a.options.numerals[+t]})),s=s.replace(/[0-9]/g,(function(t){return a.options.numerals[+t]}))),o+a.options.prefix+n+s+a.options.suffix},this.easeOutExpo=function(t,i,n,s){return n*(1-Math.pow(2,-10*t/s))*1024/1023+i},this.options=t(t({},this.defaults),s),this.formattingFn=this.options.formattingFn?this.options.formattingFn:this.formatNumber,this.easingFn=this.options.easingFn?this.options.easingFn:this.easeOutExpo,this.startVal=this.validateValue(this.options.startVal),this.frameVal=this.startVal,this.endVal=this.validateValue(n),this.options.decimalPlaces=Math.max(this.options.decimalPlaces),this.resetDuration(),this.options.separator=String(this.options.separator),this.useEasing=this.options.useEasing,""===this.options.separator&&(this.options.useGrouping=!1),this.el="string"==typeof i?document.getElementById(i):i,this.el?this.printValue(this.startVal):this.error="[CountUp] target is null or undefined","undefined"!=typeof window&&this.options.enableScrollSpy&&(this.error?console.error(this.error,i):(window.onScrollFns=window.onScrollFns||[],window.onScrollFns.push((function(){return a.handleScroll(a)})),window.onscroll=function(){window.onScrollFns.forEach((function(t){return t()}))},this.handleScroll(this)))}return i.prototype.handleScroll=function(t){if(t&&window&&!t.once){var i=window.innerHeight+window.scrollY,n=t.el.getBoundingClientRect(),s=n.top+window.pageYOffset,a=n.top+n.height+window.pageYOffset;a<i&&a>window.scrollY&&t.paused?(t.paused=!1,setTimeout((function(){return t.start()}),t.options.scrollSpyDelay),t.options.scrollSpyOnce&&(t.once=!0)):(window.scrollY>a||s>i)&&!t.paused&&t.reset()}},i.prototype.determineDirectionAndSmartEasing=function(){var t=this.finalEndVal?this.finalEndVal:this.endVal;this.countDown=this.startVal>t;var i=t-this.startVal;if(Math.abs(i)>this.options.smartEasingThreshold&&this.options.useEasing){this.finalEndVal=t;var n=this.countDown?1:-1;this.endVal=t+n*this.options.smartEasingAmount,this.duration=this.duration/2}else this.endVal=t,this.finalEndVal=null;null!==this.finalEndVal?this.useEasing=!1:this.useEasing=this.options.useEasing},i.prototype.start=function(t){this.error||(this.options.onStartCallback&&this.options.onStartCallback(),t&&(this.options.onCompleteCallback=t),this.duration>0?(this.determineDirectionAndSmartEasing(),this.paused=!1,this.rAF=requestAnimationFrame(this.count)):this.printValue(this.endVal))},i.prototype.pauseResume=function(){this.paused?(this.startTime=null,this.duration=this.remaining,this.startVal=this.frameVal,this.determineDirectionAndSmartEasing(),this.rAF=requestAnimationFrame(this.count)):cancelAnimationFrame(this.rAF),this.paused=!this.paused},i.prototype.reset=function(){cancelAnimationFrame(this.rAF),this.paused=!0,this.resetDuration(),this.startVal=this.validateValue(this.options.startVal),this.frameVal=this.startVal,this.printValue(this.startVal)},i.prototype.update=function(t){cancelAnimationFrame(this.rAF),this.startTime=null,this.endVal=this.validateValue(t),this.endVal!==this.frameVal&&(this.startVal=this.frameVal,null==this.finalEndVal&&this.resetDuration(),this.finalEndVal=null,this.determineDirectionAndSmartEasing(),this.rAF=requestAnimationFrame(this.count))},i.prototype.printValue=function(t){var i;if(this.el){var n=this.formattingFn(t);if(null===(i=this.options.plugin)||void 0===i?void 0:i.render)this.options.plugin.render(this.el,n);else if("INPUT"===this.el.tagName)this.el.value=n;else"text"===this.el.tagName||"tspan"===this.el.tagName?this.el.textContent=n:this.el.innerHTML=n}},i.prototype.ensureNumber=function(t){return"number"==typeof t&&!isNaN(t)},i.prototype.validateValue=function(t){var i=Number(t);return this.ensureNumber(i)?i:(this.error="[CountUp] invalid start or end value: ".concat(t),null)},i.prototype.resetDuration=function(){this.startTime=null,this.duration=1e3*Number(this.options.duration),this.remaining=this.duration},i}();


/***/ }),

/***/ 54484:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/summit/previous",
      function () {
        return __webpack_require__(63657);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 63657:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSP": function() { return /* binding */ __N_SSP; },
/* harmony export */   "default": function() { return /* export default binding */ __WEBPACK_DEFAULT_EXPORT__; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var styled_jsx_style__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(60357);
/* harmony import */ var styled_jsx_style__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(styled_jsx_style__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(93967);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _index_module_scss__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(87775);
/* harmony import */ var _index_module_scss__WEBPACK_IMPORTED_MODULE_16___default = /*#__PURE__*/__webpack_require__.n(_index_module_scss__WEBPACK_IMPORTED_MODULE_16__);
/* harmony import */ var swiper_css__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(25194);
/* harmony import */ var swiper_css__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(swiper_css__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var swiper_css_pagination__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(18700);
/* harmony import */ var swiper_css_pagination__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(swiper_css_pagination__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var swiper_css_navigation__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(94375);
/* harmony import */ var swiper_css_navigation__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(swiper_css_navigation__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var swiper_modules__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(6521);
/* harmony import */ var swiper_react__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(2261);
/* harmony import */ var _components_wrapper__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(65409);
/* harmony import */ var react_countup__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(17857);
/* harmony import */ var echarts__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(15304);
/* harmony import */ var _utils_useHead__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(25838);
/* harmony import */ var next_intl__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(81627);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_14__);


















var __N_SSP = true;
/* harmony default export */ function __WEBPACK_DEFAULT_EXPORT__(param) {
    var menuDetail = param.menuDetail, data = param.data, guestList = param.guestList;
    var ref, ref, ref, ref, ref, ref, ref, ref, ref, ref, ref, ref, ref, ref, ref, ref, ref, ref, ref, ref, ref, ref;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_14__.useRouter)();
    var t = (0,next_intl__WEBPACK_IMPORTED_MODULE_15__/* .useTranslations */ .T_)("summit.previous");
    var pieRef = (0,react__WEBPACK_IMPORTED_MODULE_2__.useRef)();
    var barRef = (0,react__WEBPACK_IMPORTED_MODULE_2__.useRef)();
    var pieOption = {
        tooltip: {
            trigger: "item"
        },
        series: [
            {
                type: "pie",
                radius: [
                    "40%",
                    "70%"
                ],
                animationDuration: 2000,
                padAngle: 2,
                itemStyle: {
                    borderRadius: 10
                },
                data: [
                    {
                        value: t("section5.chart1.item1num"),
                        itemStyle: {
                            color: "#a9acf4"
                        },
                        name: t("section5.chart1.item1tit")
                    },
                    {
                        value: t("section5.chart1.item2num"),
                        itemStyle: {
                            color: "#7ce1cf"
                        },
                        name: t("section5.chart1.item2tit")
                    },
                    {
                        value: t("section5.chart1.item3num"),
                        itemStyle: {
                            color: "#b5e1a6"
                        },
                        name: t("section5.chart1.item3tit")
                    },
                    {
                        value: t("section5.chart1.item4num"),
                        itemStyle: {
                            color: "#cde166"
                        },
                        name: t("section5.chart1.item4tit")
                    },
                    {
                        value: t("section5.chart1.item5num"),
                        itemStyle: {
                            color: "#f7cd45"
                        },
                        name: t("section5.chart1.item5tit")
                    },
                    {
                        value: t("section5.chart1.item6num"),
                        itemStyle: {
                            color: "#eb9435"
                        },
                        name: t("section5.chart1.item6tit")
                    }, 
                ],
                label: {
                    alignTo: "edge",
                    formatter: function formatter(params) {
                        var arr = [
                            "zero",
                            "one",
                            "two",
                            "three",
                            "four",
                            "five"
                        ];
                        return "{a|" + params.value + "%}" + "\n" + "{name|" + params.name + "}";
                    },
                    minMargin: 5,
                    edgeDistance: 60,
                    overflow: "none",
                    lineHeight: 15,
                    offset: [
                        0,
                        -20
                    ],
                    // formatter: function(params) {
                    //   const arr = ['zero', 'one', 'two', 'three', 'four'];
                    //   return '{'+ arr[params.dataIndex] +'|'+ params.value +'%}\n{name|'+ params.name +'}';
                    // },
                    // edgeDistance: 10,
                    // lineHeight: 16,
                    // rich: {
                    //   name: { fontSize: 14, color: '#fff', padding: [5, 0, 0, 0] }
                    // }
                    rich: {
                        a: {
                            fontSize: "18px",
                            fontWeight: "bold",
                            align: "center"
                        },
                        // zero: {
                        //   fontSize: '18px', fontWeight: 'bold',
                        //   align: 'center', padding: [0, 0, 0, 0]
                        // },
                        // one: {
                        //   fontSize: '18px', fontWeight: 'bold',
                        //   align: 'center', padding: [0, 0, 0, 0]
                        // },
                        // two: {
                        //   fontSize: '18px', fontWeight: 'bold',
                        //   align: 'center', padding: [0, 0, 0, 0]
                        // },
                        // three: {
                        //   fontSize: '18px', fontWeight: 'bold',
                        //   align: 'center', padding: [0, 0, 0, 0]
                        // },
                        // four: {
                        //   fontSize: '18px', fontWeight: 'bold',
                        //   align: 'center', padding: [0, 0, 0, 0]
                        // },
                        // five: {
                        //   fontSize: '18px', fontWeight: 'bold',
                        //   align: 'center', padding: [0, 0, 0, 0]
                        // },
                        name: {
                            fontSize: "14px",
                            fontWeight: "bold",
                            align: "center"
                        }
                    }
                },
                labelLine: {
                    length: 30,
                    length2: 40,
                    maxSurfaceAngle: 40,
                    normal: {
                        lineStyle: {
                            color: "#f9b000"
                        }
                    }
                },
                labelLayout: function labelLayout(params) {
                    var isLeft = params.labelRect.x < pieRef.current.getWidth() / 2;
                    var points = params.labelLinePoints;
                    // Update the end point.
                    points[2][0] = isLeft ? params.labelRect.x : params.labelRect.x + params.labelRect.width;
                    return {
                        labelLinePoints: points
                    };
                }
            }, 
        ]
    };
    var barOption = {
        tooltip: {
            trigger: "axis",
            formatter: function formatter(params) {
                // 假设 params.seriesName 是实际数据的系列名
                if (params[0].seriesName == "data") {
                    // 只返回实际数据的值
                    return params[0].name + "<br/>" + params[0].seriesName + ": " + params[0].value + "%";
                }
                // 对于剩余部分的数据，不返回任何内容，这样 tooltip 就不会显示
                return "";
            }
        },
        legend: {
            data: [
                "柱状图1",
                "柱状图2"
            ]
        },
        xAxis: [
            {
                type: "value",
                boundaryGap: [
                    0
                ],
                // position: 'bottom',
                data: [
                    "总量"
                ],
                max: 100,
                // scale: 0.8,
                axisLine: {
                    show: false // 是否显示坐标轴线
                },
                axisTick: {
                    // 控制刻度
                    show: false // 不显示刻度
                },
                axisLabel: {
                    // 控制坐标轴标签
                    show: false // 不显示坐标轴标签
                },
                splitLine: {
                    // 控制网格线
                    show: false // 不显示网格线
                }
            }
        ],
        yAxis: [
            {
                type: "category",
                inverse: true,
                max: 6,
                data: [
                    t("section5.chart2.item1tit"),
                    t("section5.chart2.item2tit"),
                    t("section5.chart2.item3tit"),
                    t("section5.chart2.item4tit"),
                    t("section5.chart2.item5tit"), 
                ],
                axisLabel: {
                    fontSize: "18px",
                    lineHeight: 20,
                    align: "right",
                    margin: 10,
                    fontWeight: "600",
                    color: "#F9B000"
                },
                axisTick: {
                    show: false
                },
                axisLine: {
                    show: false,
                    lineStyle: {
                        color: "#f5f5f5"
                    }
                }
            }
        ],
        series: [
            {
                name: "data",
                type: "bar",
                // barGap: ,
                barGap: "-120%",
                // barCategoryGap: '100%',
                stack: "data",
                itemStyle: {
                    color: "#transparent",
                    borderColor: "transparent"
                },
                z: 10,
                barWidth: 20,
                offset: [
                    20,
                    0
                ],
                data: [
                    1,
                    1,
                    1,
                    1,
                    1
                ]
            },
            {
                name: "data1",
                type: "bar",
                // barGap: ,
                barGap: "-120%",
                barCategoryGap: "50%",
                animationDuration: 2500,
                stack: "data",
                itemStyle: {
                    color: "#fff",
                    barBorderRadius: 20
                },
                label: {
                    show: true,
                    position: "left",
                    formatter: function formatter(params) {
                        return "{a|" + params.value + "%}";
                    },
                    offset: [
                        50,
                        0
                    ],
                    rich: {
                        a: {
                            fontSize: 14,
                            color: "#fcb814",
                            fontFamily: "微软雅黑",
                            fontWeight: "600"
                        }
                    }
                },
                z: 10,
                barWidth: 20,
                offset: [
                    20,
                    0
                ],
                data: [
                    t("section5.chart2.item1num"),
                    t("section5.chart2.item2num"),
                    t("section5.chart2.item3num"),
                    t("section5.chart2.item4num"),
                    t("section5.chart2.item5num"), 
                ]
            },
            {
                name: "小圆球",
                type: "pictorialBar",
                symbol: "circle",
                symbolSize: [
                    20,
                    20
                ],
                symbolOffset: [
                    35,
                    -2
                ],
                z: 3,
                itemStyle: {
                    normal: {
                        color: "#FFFFFF" // 小圆球的颜色
                    }
                },
                data: [
                    {
                        value: t("section5.chart2.item1num"),
                        symbolPosition: "end"
                    },
                    {
                        value: t("section5.chart2.item2num"),
                        symbolPosition: "end"
                    },
                    {
                        value: t("section5.chart2.item3num"),
                        symbolPosition: "end"
                    },
                    {
                        value: t("section5.chart2.item4num"),
                        symbolPosition: "end"
                    },
                    {
                        value: t("section5.chart2.item5num"),
                        symbolPosition: "end"
                    }, 
                ]
            },
            {
                name: "剩余部分",
                type: "bar",
                // stack: '总量',
                barWidth: 28,
                // label: {
                //   show: true,
                //   position: 'right',
                //   formatter: function (params: any,) {
                //     const data = [5, 13, 16, 25, 41].reverse()
                //     var percent = data[params.dataIndex] + '%'; // 计算并格式化占比
                //     return '{a|' + percent + '}';
                //   },
                //   rich: {
                //     a: {
                //       fontSize: 16,
                //       color: '#fcb814',
                //       fontFamily: '微软雅黑',
                //       fontWeight: '500'
                //     }
                //   },
                //   // padding: [4, 8, 1]
                // },
                itemStyle: {
                    // color: '#d0e4b6',
                    color: {
                        type: "linear",
                        x: 0,
                        y: 0,
                        x2: 1,
                        y2: 0,
                        colorStops: [
                            {
                                offset: 0,
                                color: "#d0e4b6"
                            },
                            {
                                offset: 0.5,
                                color: "#fcd763"
                            },
                            {
                                offset: 1,
                                color: "#f0b582"
                            }
                        ]
                    },
                    barBorderRadius: 20
                },
                data: function() {
                    return Array(5).fill(100);
                }()
            }
        ],
        grid: {
            top: "0",
            left: "0",
            right: "0",
            bottom: "0",
            containLabel: true
        }
    };
    var chunkArray = (0,react__WEBPACK_IMPORTED_MODULE_2__.useCallback)(function(arr, chunkSize) {
        var chunkedArray = [];
        var index = 0;
        while(index < arr.length){
            var end = Math.min(index + chunkSize, arr.length);
            chunkedArray.push(arr.slice(index, end));
            index = end;
        }
        return chunkedArray;
    }, []);
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        setTimeout(function() {
            var ref;
            var str = ((ref = document.getElementById("reactCode")) === null || ref === void 0 ? void 0 : ref.innerText) || "console.log()";
            eval(str);
        }, 0);
    }, [
        menuDetail
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        pieRef.current = echarts__WEBPACK_IMPORTED_MODULE_12__/* .init */ .S1(document.getElementById("pie"));
        pieRef.current.setOption(pieOption);
        barRef.current = echarts__WEBPACK_IMPORTED_MODULE_12__/* .init */ .S1(document.getElementById("bar"));
        barRef.current.setOption(barOption);
    }, [
        menuDetail
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_wrapper__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "jsx-b78f040cc1473d39" + " " + (classnames__WEBPACK_IMPORTED_MODULE_4___default()((_index_module_scss__WEBPACK_IMPORTED_MODULE_16___default().container), "m-1600") || ""),
                children: [
                    (0,_utils_useHead__WEBPACK_IMPORTED_MODULE_13__/* .getHead */ .c)(menuDetail),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "jsx-b78f040cc1473d39" + " " + ((_index_module_scss__WEBPACK_IMPORTED_MODULE_16___default().intro) || ""),
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "jsx-b78f040cc1473d39",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                    src: "/image/logo.png?v=20250422",
                                    alt: "",
                                    className: "jsx-b78f040cc1473d39"
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                                    className: "jsx-b78f040cc1473d39",
                                    children: t("section1.title")
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("ul", {
                                    className: "jsx-b78f040cc1473d39",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                            className: "jsx-b78f040cc1473d39",
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                className: "jsx-b78f040cc1473d39",
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                                                        className: "jsx-b78f040cc1473d39",
                                                        children: [
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_countup__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .ZP, {
                                                                end: Number(t("section1.item1num")),
                                                                duration: 1,
                                                                enableScrollSpy: true
                                                            }),
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                                className: "jsx-b78f040cc1473d39"
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                        className: "jsx-b78f040cc1473d39",
                                                        children: t("section1.item1tit")
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                            className: "jsx-b78f040cc1473d39",
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                className: "jsx-b78f040cc1473d39",
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                                                        className: "jsx-b78f040cc1473d39",
                                                        children: [
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_countup__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .ZP, {
                                                                end: Number(t("section1.item2num")),
                                                                duration: 1,
                                                                enableScrollSpy: true
                                                            }),
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                                className: "jsx-b78f040cc1473d39"
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                        className: "jsx-b78f040cc1473d39",
                                                        children: t("section1.item2tit")
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                            className: "jsx-b78f040cc1473d39",
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                className: "jsx-b78f040cc1473d39",
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                                                        className: "jsx-b78f040cc1473d39",
                                                        children: [
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_countup__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .ZP, {
                                                                end: Number(t("section1.item3num")),
                                                                duration: 1,
                                                                enableScrollSpy: true
                                                            }),
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                                className: "jsx-b78f040cc1473d39",
                                                                children: "+"
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                        className: "jsx-b78f040cc1473d39",
                                                        children: t("section1.item3tit")
                                                    })
                                                ]
                                            })
                                        })
                                    ]
                                }),
                                t.rich("section1.text", {
                                    p: function(chunks) {
                                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                            className: "jsx-b78f040cc1473d39",
                                            children: chunks
                                        });
                                    },
                                    br: function() {
                                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {
                                            className: "jsx-b78f040cc1473d39"
                                        });
                                    }
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                        src: "https://img.cbcechina.com/2024-11-26/79a872efa046ad03e1642fc57d7f1362.png",
                        alt: "",
                        className: "jsx-b78f040cc1473d39"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "jsx-b78f040cc1473d39" + " " + ((_index_module_scss__WEBPACK_IMPORTED_MODULE_16___default().vLogo) || ""),
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("h3", {
                                className: "jsx-b78f040cc1473d39",
                                children: [
                                    t("section2.title"),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                        className: "jsx-b78f040cc1473d39",
                                        children: t("section2.subtitle")
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(swiper_react__WEBPACK_IMPORTED_MODULE_9__/* .Swiper */ .tq, {
                                className: (_index_module_scss__WEBPACK_IMPORTED_MODULE_16___default().swiper),
                                modules: [
                                    swiper_modules__WEBPACK_IMPORTED_MODULE_8__/* .Autoplay */ .pt,
                                    swiper_modules__WEBPACK_IMPORTED_MODULE_8__/* .Pagination */ .tl
                                ],
                                spaceBetween: 0,
                                autoplay: true,
                                pagination: {
                                    clickable: true
                                },
                                slidesPerView: 1,
                                children: data.spectator_list && ((ref = chunkArray(data.spectator_list, 27)) === null || ref === void 0 ? void 0 : ref.map(function(item, index) {
                                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(swiper_react__WEBPACK_IMPORTED_MODULE_9__/* .SwiperSlide */ .o5, {
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("ul", {
                                            className: "jsx-b78f040cc1473d39" + " " + ((_index_module_scss__WEBPACK_IMPORTED_MODULE_16___default().audiList) || ""),
                                            children: item.map(function(child, idx) {
                                                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                                    className: "jsx-b78f040cc1473d39",
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_3___default()), {
                                                        href: child["link_".concat(router.locale)] ? child["link_".concat(router.locale)] : "javascript:;",
                                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                            target: child["link_".concat(router.locale)] ? "_blank" : "_self",
                                                            className: "jsx-b78f040cc1473d39",
                                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                                                loading: "lazy",
                                                                src: child.image,
                                                                alt: child["title_".concat(router.locale)],
                                                                className: "jsx-b78f040cc1473d39"
                                                            })
                                                        })
                                                    })
                                                }, idx);
                                            })
                                        })
                                    }, index);
                                }))
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "jsx-b78f040cc1473d39" + " " + ((_index_module_scss__WEBPACK_IMPORTED_MODULE_16___default().vComment) || ""),
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                                className: "jsx-b78f040cc1473d39",
                                children: t("section3.title")
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "jsx-b78f040cc1473d39",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: "jsx-b78f040cc1473d39" + " " + ((_index_module_scss__WEBPACK_IMPORTED_MODULE_16___default().left) || ""),
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(swiper_react__WEBPACK_IMPORTED_MODULE_9__/* .Swiper */ .tq, {
                                            autoplay: true,
                                            modules: [
                                                swiper_modules__WEBPACK_IMPORTED_MODULE_8__/* .Autoplay */ .pt,
                                                swiper_modules__WEBPACK_IMPORTED_MODULE_8__/* .Pagination */ .tl
                                            ],
                                            slidesPerView: 1,
                                            autoHeight: true,
                                            pagination: {
                                                clickable: true
                                            },
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(swiper_react__WEBPACK_IMPORTED_MODULE_9__/* .SwiperSlide */ .o5, {
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                    className: "jsx-b78f040cc1473d39" + " " + ((_index_module_scss__WEBPACK_IMPORTED_MODULE_16___default().swiperItem) || ""),
                                                    children: [
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                            className: "jsx-b78f040cc1473d39" + " " + ((_index_module_scss__WEBPACK_IMPORTED_MODULE_16___default().logo) || ""),
                                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                className: "jsx-b78f040cc1473d39",
                                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                                                    src: "https://img.cbcechina.com/2026-11-02/2f1d231a4248771b07bf160ea2234f14.png",
                                                                    alt: "",
                                                                    className: "jsx-b78f040cc1473d39"
                                                                })
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                            className: "jsx-b78f040cc1473d39" + " " + ((_index_module_scss__WEBPACK_IMPORTED_MODULE_16___default().name) || ""),
                                                            children: t("section3.item1name")
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                            className: "jsx-b78f040cc1473d39" + " " + ((_index_module_scss__WEBPACK_IMPORTED_MODULE_16___default().position) || ""),
                                                            children: t("section3.item1label")
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                            className: "jsx-b78f040cc1473d39",
                                                            children: t("section3.item1txt")
                                                        })
                                                    ]
                                                })
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: "jsx-b78f040cc1473d39" + " " + ((_index_module_scss__WEBPACK_IMPORTED_MODULE_16___default().right) || ""),
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(swiper_react__WEBPACK_IMPORTED_MODULE_9__/* .Swiper */ .tq, {
                                            autoplay: true,
                                            modules: [
                                                swiper_modules__WEBPACK_IMPORTED_MODULE_8__/* .Autoplay */ .pt,
                                                swiper_modules__WEBPACK_IMPORTED_MODULE_8__/* .Pagination */ .tl
                                            ],
                                            slidesPerView: 1,
                                            autoHeight: true,
                                            pagination: {
                                                clickable: true
                                            },
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(swiper_react__WEBPACK_IMPORTED_MODULE_9__/* .SwiperSlide */ .o5, {
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                    className: "jsx-b78f040cc1473d39" + " " + ((_index_module_scss__WEBPACK_IMPORTED_MODULE_16___default().swiperItem) || ""),
                                                    children: [
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                            className: "jsx-b78f040cc1473d39" + " " + ((_index_module_scss__WEBPACK_IMPORTED_MODULE_16___default().logo) || ""),
                                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                className: "jsx-b78f040cc1473d39",
                                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                                                    src: "https://img.cbcechina.com/2026-11-02/e78c4d36cce415bd09f30c495a74eea7.png",
                                                                    alt: "",
                                                                    className: "jsx-b78f040cc1473d39"
                                                                })
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                            className: "jsx-b78f040cc1473d39" + " " + ((_index_module_scss__WEBPACK_IMPORTED_MODULE_16___default().name) || ""),
                                                            children: t("section3.item2name")
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                            className: "jsx-b78f040cc1473d39" + " " + ((_index_module_scss__WEBPACK_IMPORTED_MODULE_16___default().position) || ""),
                                                            children: t("section3.item2label")
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                            className: "jsx-b78f040cc1473d39",
                                                            children: t("section3.item2txt")
                                                        })
                                                    ]
                                                })
                                            })
                                        })
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "jsx-b78f040cc1473d39" + " " + ((_index_module_scss__WEBPACK_IMPORTED_MODULE_16___default().photo) || ""),
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                                className: "jsx-b78f040cc1473d39",
                                children: t("section4.title")
                            }),
                            data.atlas_list && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "jsx-b78f040cc1473d39" + " " + ((_index_module_scss__WEBPACK_IMPORTED_MODULE_16___default().photoList) || ""),
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                        className: "jsx-b78f040cc1473d39" + " " + ((_index_module_scss__WEBPACK_IMPORTED_MODULE_16___default().top) || ""),
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                                src: (ref = data.atlas_list[0]) === null || ref === void 0 ? void 0 : ref.photo,
                                                alt: (ref = data.atlas_list[0]) === null || ref === void 0 ? void 0 : ref["brief_".concat(router.locale)],
                                                className: "jsx-b78f040cc1473d39"
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                className: "jsx-b78f040cc1473d39",
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                                        src: (ref = data.atlas_list[1]) === null || ref === void 0 ? void 0 : ref.photo,
                                                        alt: (ref = data.atlas_list[1]) === null || ref === void 0 ? void 0 : ref["brief_".concat(router.locale)],
                                                        className: "jsx-b78f040cc1473d39"
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                                        src: (ref = data.atlas_list[2]) === null || ref === void 0 ? void 0 : ref.photo,
                                                        alt: (ref = data.atlas_list[2]) === null || ref === void 0 ? void 0 : ref["brief_".concat(router.locale)],
                                                        className: "jsx-b78f040cc1473d39"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                                src: (ref = data.atlas_list[3]) === null || ref === void 0 ? void 0 : ref.photo,
                                                alt: (ref = data.atlas_list[3]) === null || ref === void 0 ? void 0 : ref["brief_".concat(router.locale)],
                                                className: "jsx-b78f040cc1473d39"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                        className: "jsx-b78f040cc1473d39" + " " + ((_index_module_scss__WEBPACK_IMPORTED_MODULE_16___default().bottom) || ""),
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                className: "jsx-b78f040cc1473d39",
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                                        src: (ref = data.atlas_list[4]) === null || ref === void 0 ? void 0 : ref.photo,
                                                        alt: (ref = data.atlas_list[4]) === null || ref === void 0 ? void 0 : ref["brief_".concat(router.locale)],
                                                        className: "jsx-b78f040cc1473d39"
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                                        src: (ref = data.atlas_list[5]) === null || ref === void 0 ? void 0 : ref.photo,
                                                        alt: (ref = data.atlas_list[5]) === null || ref === void 0 ? void 0 : ref["brief_".concat(router.locale)],
                                                        className: "jsx-b78f040cc1473d39"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                                src: (ref = data.atlas_list[6]) === null || ref === void 0 ? void 0 : ref.photo,
                                                alt: (ref = data.atlas_list[6]) === null || ref === void 0 ? void 0 : ref["brief_".concat(router.locale)],
                                                className: "jsx-b78f040cc1473d39"
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                                src: (ref = data.atlas_list[7]) === null || ref === void 0 ? void 0 : ref.photo,
                                                alt: (ref = data.atlas_list[7]) === null || ref === void 0 ? void 0 : ref["brief_".concat(router.locale)],
                                                className: "jsx-b78f040cc1473d39"
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                                src: (ref = data.atlas_list[8]) === null || ref === void 0 ? void 0 : ref.photo,
                                                alt: (ref = data.atlas_list[8]) === null || ref === void 0 ? void 0 : ref["brief_".concat(router.locale)],
                                                className: "jsx-b78f040cc1473d39"
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                href: "/media/photo",
                                className: "jsx-b78f040cc1473d39",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: "jsx-b78f040cc1473d39" + " " + (classnames__WEBPACK_IMPORTED_MODULE_4___default()([
                                        (_index_module_scss__WEBPACK_IMPORTED_MODULE_16___default().more),
                                        "btnStyle"
                                    ]) || ""),
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                            className: "jsx-b78f040cc1473d39",
                                            children: t("section4.more")
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
                                            t: "1723196878237",
                                            viewBox: "0 0 1024 1024",
                                            version: "1.1",
                                            xmlns: "http://www.w3.org/2000/svg",
                                            "p-id": "2672",
                                            width: "14",
                                            height: "14",
                                            className: "jsx-b78f040cc1473d39" + " " + "icon",
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                                d: "M320 0 192 128l384 384-384 384 128 128 512-512L320 0z",
                                                "p-id": "2673",
                                                fill: "#231F20",
                                                className: "jsx-b78f040cc1473d39"
                                            })
                                        })
                                    ]
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        dangerouslySetInnerHTML: {
                            __html: menuDetail === null || menuDetail === void 0 ? void 0 : (ref = menuDetail.info) === null || ref === void 0 ? void 0 : ref.content
                        },
                        className: "jsx-b78f040cc1473d39"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
                        className: "jsx-b78f040cc1473d39" + " " + ((_index_module_scss__WEBPACK_IMPORTED_MODULE_16___default().guests) || ""),
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "jsx-b78f040cc1473d39" + " " + (classnames__WEBPACK_IMPORTED_MODULE_4___default()((_index_module_scss__WEBPACK_IMPORTED_MODULE_16___default().inner)) || ""),
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                                    className: "jsx-b78f040cc1473d39",
                                    children: t("section8.title")
                                }),
                                 false ? /*#__PURE__*/ 0 : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("ul", {
                                    className: "jsx-b78f040cc1473d39" + " " + ((_index_module_scss__WEBPACK_IMPORTED_MODULE_16___default().list) || ""),
                                    children: guestList === null || guestList === void 0 ? void 0 : guestList.map(function(item, index) {
                                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("li", {
                                            className: "jsx-b78f040cc1473d39" + " " + ((_index_module_scss__WEBPACK_IMPORTED_MODULE_16___default().item) || ""),
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                    className: "jsx-b78f040cc1473d39" + " " + ((_index_module_scss__WEBPACK_IMPORTED_MODULE_16___default().avatar) || ""),
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                                        src: item.image,
                                                        alt: item["title_".concat(router.locale)],
                                                        loading: "lazy",
                                                        className: "jsx-b78f040cc1473d39"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                    className: "jsx-b78f040cc1473d39" + " " + ((_index_module_scss__WEBPACK_IMPORTED_MODULE_16___default().title) || ""),
                                                    children: item["title_".concat(router.locale)]
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                    className: "jsx-b78f040cc1473d39" + " " + ((_index_module_scss__WEBPACK_IMPORTED_MODULE_16___default().brief) || ""),
                                                    children: item["brief_".concat(router.locale)]
                                                })
                                            ]
                                        }, index);
                                    })
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "jsx-b78f040cc1473d39" + " " + ((_index_module_scss__WEBPACK_IMPORTED_MODULE_16___default().data) || ""),
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                                className: "jsx-b78f040cc1473d39",
                                children: t("section5.title")
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                className: "jsx-b78f040cc1473d39",
                                children: t("section5.text")
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "jsx-b78f040cc1473d39",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                        className: "jsx-b78f040cc1473d39",
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h4", {
                                                className: "jsx-b78f040cc1473d39",
                                                children: t("section5.chart1.title")
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                id: "pie",
                                                className: "jsx-b78f040cc1473d39" + " " + ((_index_module_scss__WEBPACK_IMPORTED_MODULE_16___default().pie) || "")
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                        className: "jsx-b78f040cc1473d39",
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h4", {
                                                className: "jsx-b78f040cc1473d39",
                                                children: t("section5.chart2.title")
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                id: "bar",
                                                className: "jsx-b78f040cc1473d39" + " " + ((_index_module_scss__WEBPACK_IMPORTED_MODULE_16___default().bar) || "")
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "jsx-b78f040cc1473d39" + " " + ((_index_module_scss__WEBPACK_IMPORTED_MODULE_16___default().sponsor) || ""),
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("h3", {
                                className: "jsx-b78f040cc1473d39",
                                children: [
                                    t("section6.title"),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                        className: "jsx-b78f040cc1473d39",
                                        children: t("section6.subtitle")
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(swiper_react__WEBPACK_IMPORTED_MODULE_9__/* .Swiper */ .tq, {
                                className: (_index_module_scss__WEBPACK_IMPORTED_MODULE_16___default().swiper),
                                modules: [
                                    swiper_modules__WEBPACK_IMPORTED_MODULE_8__/* .Autoplay */ .pt,
                                    swiper_modules__WEBPACK_IMPORTED_MODULE_8__/* .Pagination */ .tl
                                ],
                                spaceBetween: 0,
                                autoplay: true,
                                pagination: {
                                    clickable: true
                                },
                                slidesPerView: 1,
                                children: data.brand_list && ((ref = chunkArray(data.brand_list, 18)) === null || ref === void 0 ? void 0 : ref.map(function(item, index) {
                                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(swiper_react__WEBPACK_IMPORTED_MODULE_9__/* .SwiperSlide */ .o5, {
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("ul", {
                                            className: "jsx-b78f040cc1473d39" + " " + ((_index_module_scss__WEBPACK_IMPORTED_MODULE_16___default().audiList) || ""),
                                            children: item.map(function(child, idx) {
                                                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                                    className: "jsx-b78f040cc1473d39",
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_3___default()), {
                                                        href: child["link_".concat(router.locale)] ? child["link_".concat(router.locale)] : "javascript:;",
                                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                            target: child["link_".concat(router.locale)] ? "_blank" : "_self",
                                                            className: "jsx-b78f040cc1473d39",
                                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                                                loading: "lazy",
                                                                src: child.image,
                                                                alt: child["title_".concat(router.locale)],
                                                                className: "jsx-b78f040cc1473d39"
                                                            })
                                                        })
                                                    })
                                                }, idx);
                                            })
                                        })
                                    }, index);
                                }))
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "jsx-b78f040cc1473d39" + " " + ((_index_module_scss__WEBPACK_IMPORTED_MODULE_16___default().lookback) || ""),
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                                className: "jsx-b78f040cc1473d39",
                                children: t("section7.title")
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(swiper_react__WEBPACK_IMPORTED_MODULE_9__/* .Swiper */ .tq, {
                                onObserverUpdate: function(swiper) {
                                    swiper.slideNext();
                                },
                                autoplay: true,
                                className: "lookback",
                                modules: [
                                    swiper_modules__WEBPACK_IMPORTED_MODULE_8__/* .Autoplay */ .pt,
                                    swiper_modules__WEBPACK_IMPORTED_MODULE_8__/* .Pagination */ .tl
                                ],
                                slidesPerView: "auto",
                                pagination: {
                                    clickable: true
                                },
                                children: (ref = data.review_list) === null || ref === void 0 ? void 0 : ref.map(function(item, index) {
                                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(swiper_react__WEBPACK_IMPORTED_MODULE_9__/* .SwiperSlide */ .o5, {
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_3___default()), {
                                            href: item.file,
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("a", {
                                                target: "_blank",
                                                className: "jsx-b78f040cc1473d39" + " " + ((_index_module_scss__WEBPACK_IMPORTED_MODULE_16___default().lookItem) || ""),
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                                                        className: "jsx-b78f040cc1473d39",
                                                        children: [
                                                            item.title,
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                                className: "jsx-b78f040cc1473d39",
                                                                children: t("section7.unit")
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                        className: "jsx-b78f040cc1473d39",
                                                        children: t("section7.label")
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                        style: {
                                                            opacity: "".concat(1 - index * 0.09)
                                                        },
                                                        className: "jsx-b78f040cc1473d39" + " " + ((_index_module_scss__WEBPACK_IMPORTED_MODULE_16___default().bg) || "")
                                                    })
                                                ]
                                            })
                                        })
                                    }, index);
                                })
                            })
                        ]
                    }),
                    (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((styled_jsx_style__WEBPACK_IMPORTED_MODULE_1___default()), {
                        id: "b78f040cc1473d39",
                        children: ".lookback .swiper-wrapper :first-child a{background-image:url(/image/lookback-li-first-bg.png);-webkit-background-size:100%100%;-moz-background-size:100%100%;-o-background-size:100%100%;background-size:100%100%}.swiper-slide{width:auto;padding-bottom:30px}.swiper-pagination{bottom:0!important}.swiper-pagination-bullet{width:40px;height:6px;-webkit-border-radius:2px;-moz-border-radius:2px;border-radius:2px;background-color:#231f20}.swiper-pagination-bullet{background-color:rgb(0 0 0/80%)}.swiper-pagination-bullet-active{background-color:#f6a800!important}"
                    })
                ]
            })
        })
    });
};


/***/ }),

/***/ 87775:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"m-1600":"previous_m-1600__has4g","container":"previous_container__qylLW","intro":"previous_intro__561Y7","vLogo":"previous_vLogo___HWSQ","vComment":"previous_vComment__swYZo","swiperItem":"previous_swiperItem__S13ox","logo":"previous_logo__E5kMv","name":"previous_name__UPivE","position":"previous_position__l4yaZ","left":"previous_left__rUa30","right":"previous_right__q3wlJ","photo":"previous_photo__dOKXZ","more":"previous_more__4zbNC","photoList":"previous_photoList__6qpl6","top":"previous_top__uSUoZ","bottom":"previous_bottom__wSATu","guests":"previous_guests__wrG_Q","swiper":"previous_swiper__OrfmH","list":"previous_list__iCgsa","item":"previous_item__TubLo","avatar":"previous_avatar__TEgYf","title":"previous_title__VQONW","brief":"previous_brief__6elcI","data":"previous_data__kGVMA","pie":"previous_pie__gTOMA","bar":"previous_bar__yGKrm","sponsor":"previous_sponsor__uFDZO","lookback":"previous_lookback__89c7A","lookItem":"previous_lookItem__ezjv9","bg":"previous_bg__Q5DJI"};

/***/ }),

/***/ 17857:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;


__webpack_unused_export__ = ({ value: true });

var React = __webpack_require__(67294);
var countup_js = __webpack_require__(8273);

function _iterableToArrayLimit(r, l) {
  var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (null != t) {
    var e,
      n,
      i,
      u,
      a = [],
      f = !0,
      o = !1;
    try {
      if (i = (t = t.call(r)).next, 0 === l) {
        if (Object(t) !== t) return;
        f = !1;
      } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
    } catch (r) {
      o = !0, n = r;
    } finally {
      try {
        if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return;
      } finally {
        if (o) throw n;
      }
    }
    return a;
  }
}
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread2(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
function _toPrimitive(t, r) {
  if ("object" != typeof t || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != typeof i) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == typeof i ? i : String(i);
}
function _defineProperty(obj, key, value) {
  key = _toPropertyKey(key);
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}
function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}
function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
  return arr2;
}
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

/**
 * Silence SSR Warnings.
 * Borrowed from Formik v2.1.1, Licensed MIT.
 *
 * https://github.com/formium/formik/blob/9316a864478f8fcd4fa99a0735b1d37afdf507dc/LICENSE
 */
var useIsomorphicLayoutEffect = typeof window !== 'undefined' && typeof window.document !== 'undefined' && typeof window.document.createElement !== 'undefined' ? React.useLayoutEffect : React.useEffect;

/* eslint-disable @typescript-eslint/no-explicit-any */

/**
 * Create a stable reference to a callback which is updated after each render is committed.
 * Typed version borrowed from Formik v2.2.1. Licensed MIT.
 *
 * https://github.com/formium/formik/blob/9316a864478f8fcd4fa99a0735b1d37afdf507dc/LICENSE
 */
function useEventCallback(fn) {
  var ref = React.useRef(fn);

  // we copy a ref to the callback scoped to the current state/props on each render
  useIsomorphicLayoutEffect(function () {
    ref.current = fn;
  });
  return React.useCallback(function () {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    return ref.current.apply(void 0, args);
  }, []);
}

var createCountUpInstance = function createCountUpInstance(el, props) {
  var decimal = props.decimal,
    decimals = props.decimals,
    duration = props.duration,
    easingFn = props.easingFn,
    end = props.end,
    formattingFn = props.formattingFn,
    numerals = props.numerals,
    prefix = props.prefix,
    separator = props.separator,
    start = props.start,
    suffix = props.suffix,
    useEasing = props.useEasing,
    useGrouping = props.useGrouping,
    useIndianSeparators = props.useIndianSeparators,
    enableScrollSpy = props.enableScrollSpy,
    scrollSpyDelay = props.scrollSpyDelay,
    scrollSpyOnce = props.scrollSpyOnce,
    plugin = props.plugin;
  return new countup_js.CountUp(el, end, {
    startVal: start,
    duration: duration,
    decimal: decimal,
    decimalPlaces: decimals,
    easingFn: easingFn,
    formattingFn: formattingFn,
    numerals: numerals,
    separator: separator,
    prefix: prefix,
    suffix: suffix,
    plugin: plugin,
    useEasing: useEasing,
    useIndianSeparators: useIndianSeparators,
    useGrouping: useGrouping,
    enableScrollSpy: enableScrollSpy,
    scrollSpyDelay: scrollSpyDelay,
    scrollSpyOnce: scrollSpyOnce
  });
};

var _excluded$1 = ["ref", "startOnMount", "enableReinitialize", "delay", "onEnd", "onStart", "onPauseResume", "onReset", "onUpdate"];
var DEFAULTS = {
  decimal: '.',
  separator: ',',
  delay: null,
  prefix: '',
  suffix: '',
  duration: 2,
  start: 0,
  decimals: 0,
  startOnMount: true,
  enableReinitialize: true,
  useEasing: true,
  useGrouping: true,
  useIndianSeparators: false
};
var useCountUp = function useCountUp(props) {
  var filteredProps = Object.fromEntries(Object.entries(props).filter(function (_ref) {
    var _ref2 = _slicedToArray(_ref, 2),
      value = _ref2[1];
    return value !== undefined;
  }));
  var _useMemo = React.useMemo(function () {
      return _objectSpread2(_objectSpread2({}, DEFAULTS), filteredProps);
    }, [props]),
    ref = _useMemo.ref,
    startOnMount = _useMemo.startOnMount,
    enableReinitialize = _useMemo.enableReinitialize,
    delay = _useMemo.delay,
    onEnd = _useMemo.onEnd,
    onStart = _useMemo.onStart,
    onPauseResume = _useMemo.onPauseResume,
    onReset = _useMemo.onReset,
    onUpdate = _useMemo.onUpdate,
    instanceProps = _objectWithoutProperties(_useMemo, _excluded$1);
  var countUpRef = React.useRef();
  var timerRef = React.useRef();
  var isInitializedRef = React.useRef(false);
  var createInstance = useEventCallback(function () {
    return createCountUpInstance(typeof ref === 'string' ? ref : ref.current, instanceProps);
  });
  var getCountUp = useEventCallback(function (recreate) {
    var countUp = countUpRef.current;
    if (countUp && !recreate) {
      return countUp;
    }
    var newCountUp = createInstance();
    countUpRef.current = newCountUp;
    return newCountUp;
  });
  var start = useEventCallback(function () {
    var run = function run() {
      return getCountUp(true).start(function () {
        onEnd === null || onEnd === void 0 || onEnd({
          pauseResume: pauseResume,
          reset: reset,
          start: restart,
          update: update
        });
      });
    };
    if (delay && delay > 0) {
      timerRef.current = setTimeout(run, delay * 1000);
    } else {
      run();
    }
    onStart === null || onStart === void 0 || onStart({
      pauseResume: pauseResume,
      reset: reset,
      update: update
    });
  });
  var pauseResume = useEventCallback(function () {
    getCountUp().pauseResume();
    onPauseResume === null || onPauseResume === void 0 || onPauseResume({
      reset: reset,
      start: restart,
      update: update
    });
  });
  var reset = useEventCallback(function () {
    // Quick fix for https://github.com/glennreyes/react-countup/issues/736 - should be investigated
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    if (getCountUp().el) {
      timerRef.current && clearTimeout(timerRef.current);
      getCountUp().reset();
      onReset === null || onReset === void 0 || onReset({
        pauseResume: pauseResume,
        start: restart,
        update: update
      });
    }
  });
  var update = useEventCallback(function (newEnd) {
    getCountUp().update(newEnd);
    onUpdate === null || onUpdate === void 0 || onUpdate({
      pauseResume: pauseResume,
      reset: reset,
      start: restart
    });
  });
  var restart = useEventCallback(function () {
    reset();
    start();
  });
  var maybeInitialize = useEventCallback(function (shouldReset) {
    if (startOnMount) {
      if (shouldReset) {
        reset();
      }
      start();
    }
  });
  React.useEffect(function () {
    if (!isInitializedRef.current) {
      isInitializedRef.current = true;
      maybeInitialize();
    } else if (enableReinitialize) {
      maybeInitialize(true);
    }
  }, [enableReinitialize, isInitializedRef, maybeInitialize, delay, props.start, props.suffix, props.prefix, props.duration, props.separator, props.decimals, props.decimal, props.formattingFn]);
  React.useEffect(function () {
    return function () {
      reset();
    };
  }, [reset]);
  return {
    start: restart,
    pauseResume: pauseResume,
    reset: reset,
    update: update,
    getCountUp: getCountUp
  };
};

var _excluded = ["className", "redraw", "containerProps", "children", "style"];
var CountUp = function CountUp(props) {
  var className = props.className,
    redraw = props.redraw,
    containerProps = props.containerProps,
    children = props.children,
    style = props.style,
    useCountUpProps = _objectWithoutProperties(props, _excluded);
  var containerRef = React.useRef(null);
  var isInitializedRef = React.useRef(false);
  var _useCountUp = useCountUp(_objectSpread2(_objectSpread2({}, useCountUpProps), {}, {
      ref: containerRef,
      startOnMount: typeof children !== 'function' || props.delay === 0,
      // component manually restarts
      enableReinitialize: false
    })),
    start = _useCountUp.start,
    reset = _useCountUp.reset,
    updateCountUp = _useCountUp.update,
    pauseResume = _useCountUp.pauseResume,
    getCountUp = _useCountUp.getCountUp;
  var restart = useEventCallback(function () {
    start();
  });
  var update = useEventCallback(function (end) {
    if (!props.preserveValue) {
      reset();
    }
    updateCountUp(end);
  });
  var initializeOnMount = useEventCallback(function () {
    if (typeof props.children === 'function') {
      // Warn when user didn't use containerRef at all
      if (!(containerRef.current instanceof Element)) {
        console.error("Couldn't find attached element to hook the CountUp instance into! Try to attach \"containerRef\" from the render prop to a an Element, eg. <span ref={containerRef} />.");
        return;
      }
    }

    // unlike the hook, the CountUp component initializes on mount
    getCountUp();
  });
  React.useEffect(function () {
    initializeOnMount();
  }, [initializeOnMount]);
  React.useEffect(function () {
    if (isInitializedRef.current) {
      update(props.end);
    }
  }, [props.end, update]);
  var redrawDependencies = redraw && props;

  // if props.redraw, call this effect on every props change
  React.useEffect(function () {
    if (redraw && isInitializedRef.current) {
      restart();
    }
  }, [restart, redraw, redrawDependencies]);

  // if not props.redraw, call this effect only when certain props are changed
  React.useEffect(function () {
    if (!redraw && isInitializedRef.current) {
      restart();
    }
  }, [restart, redraw, props.start, props.suffix, props.prefix, props.duration, props.separator, props.decimals, props.decimal, props.className, props.formattingFn]);
  React.useEffect(function () {
    isInitializedRef.current = true;
  }, []);
  if (typeof children === 'function') {
    // TypeScript forces functional components to return JSX.Element | null.
    return children({
      countUpRef: containerRef,
      start: start,
      reset: reset,
      update: updateCountUp,
      pauseResume: pauseResume,
      getCountUp: getCountUp
    });
  }
  return /*#__PURE__*/React.createElement("span", _extends({
    className: className,
    ref: containerRef,
    style: style
  }, containerProps), typeof props.start !== 'undefined' ? getCountUp().formattingFn(props.start) : '');
};

exports.ZP = CountUp;
__webpack_unused_export__ = useCountUp;


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [127,304,342,774,888,179], function() { return __webpack_exec__(54484); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);